// Theme-native filtering for complete, rendered starter collections; no app/API key.
// Never pretend to filter the whole catalogue when pagination has omitted cards.
if (!customElements.get('hv-collection-filters')) {
  customElements.define('hv-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const initialise = () => {
        const container = this.closest('results-list');
        const cards = [...(container?.querySelectorAll('li[data-hv-sizes]') || [])];
        if (cards.length !== Number(this.dataset.total)) { this.hidden = true; return; }
        this.ready = true;
        const size = this.querySelector('[name="hv-size"]');
        const colour = this.querySelector('[name="hv-colour"]');
        const clear = this.querySelector('button');
        const count = this.querySelector('[aria-live]');
        const empty = this.querySelector('[data-empty]');
        const sizes = [...new Set(cards.flatMap(card => card.dataset.hvSizes.split('|').filter(Boolean)))];
        const sequence = ['XXS','XS','S','M','L','XL','XXL','3XL','4XL'];
        sizes.sort((a,b) => {
          if (a.startsWith('UK ') !== b.startsWith('UK ')) return a.startsWith('UK ') ? 1 : -1;
          if (a.startsWith('UK ') && b.startsWith('UK ')) return parseFloat(a.slice(3))-parseFloat(b.slice(3));
          if (sequence.includes(a) && sequence.includes(b)) return sequence.indexOf(a)-sequence.indexOf(b);
          return a.localeCompare(b, 'en-GB', {numeric:true});
        });
        const colours = [...new Set(cards.map(card => card.dataset.hvColour).filter(Boolean))].sort();
        for (const [select,values] of [[size,sizes],[colour,colours]]) {
          for (const value of values) select.add(new Option(value,value));
          select.disabled = !values.length;
        }
        const apply = () => {
          let visible = 0;
          for (const card of cards) {
            const match = (!size.value || card.dataset.hvSizes.split('|').includes(size.value)) && (!colour.value || card.dataset.hvColour === colour.value);
            card.hidden = !match;
            if (match) visible++;
          }
          count.textContent = `${visible} of ${cards.length} ${cards.length === 1 ? 'piece' : 'pieces'}`;
          clear.hidden = !size.value && !colour.value;
          empty.hidden = visible !== 0;
        };
        size.addEventListener('change',apply);
        colour.addEventListener('change',apply);
        clear.addEventListener('click',()=>{size.value='';colour.value='';apply();});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true});
      else initialise();
    }
  });
}
